var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeOpenedIcon = function SvgEyeOpenedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M4 11.053s2.356 4.71 8.637 4.71 8.638-4.71 8.638-4.71M4 11.445s2.356-4.711 8.637-4.711 8.638 4.711 8.638 4.711"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.349 8.697a4.711 4.711 0 1 1-9.326-.956c1.217-.588 2.741-1.007 4.614-1.007 1.874 0 3.398.419 4.615 1.007q.096.464.097.956m-7.44.324c-.185.116-.277.208-.301.243l-.504-.346c.095-.139.272-.284.479-.415.216-.136.495-.273.82-.384a4.4 4.4 0 0 1 2.447-.113l-.144.594a3.8 3.8 0 0 0-2.106.098 3.3 3.3 0 0 0-.692.323",
    clipRule: "evenodd"
  })));
};
export default SvgEyeOpenedIcon;